// extracted by mini-css-extract-plugin
export const container = "gif-module--container--p6cch";